import reduce from 'lodash/reduce';

export const breakpoints = {
	0: 'small',
	576: 'medium',
	767: 'large',
	992: 'xlarge',
	1200: 'xxlarge',
	1600: 'xxxlarge'
};


// Must match $breakpoints map in client/scss/lib/_breakpoint.scss
export const FOUNDATION_LARGE_PX = 1024;
export const FOUNDATION_MEDIUM_PX = 640;

export const HEADER_BREAKPOINT_PX = 1133;

export const breakpointsByName = reduce(
	breakpoints, (result, value, key) => ({ ...result, [value]: parseInt(key) }), {}
);
